import { getStepStyles } from '../../../shared/styles';

export const getkeywordStepStyles = () => ({
  keywordsStep: {
    ...getStepStyles(),
  },
});
